export const actions = {
	create   : "Запись успешно добавлена.",
	update   : "Запись успешно обновлена.",
	delete   : "Запись успешно удалена.",
	restore  : "Запись успешно восстановлена.",
	download : "Данные из файла успешно загружены."
}
export default actions